import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

class AssignmentCommentsRow extends React.Component {
  // Comments logged by the submission validation have no author.
  getAuthor() {
    const createdBy = this.props.item.createdBy;

    if (!createdBy) {
      return 'Auto-Validation';
    }

    return `${createdBy.name} ${createdBy.lastName}`;
  }

  getItem() {
    return (
      <Row>
        <Col sm={4}>
          <div className="change-text">{this.getAuthor()}</div>
        </Col>
        <Col sm={4}>
          <div className="change-text">
            {moment(this.props.item.createdAt).format('MM/DD/YYYY')}
          </div>
        </Col>
        <Col sm={4}>
          <div className="change-text">
            {this.props.item.comment !== '' ? this.props.item.comment : '-'}
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    return <div>{this.getItem()}</div>;
  }
}

AssignmentCommentsRow.propTypes = {
  item: PropTypes.object,
};

export default AssignmentCommentsRow;
